import {
    USER_PERMISSIONS_REQUEST,
    USER_PERMISSIONS_SUCCESS,
    USER_PERMISSIONS_FAILURE,
    ASSIGN_USER_PERMISSIONS_REQUEST,
    ASSIGN_USER_PERMISSIONS_SUCCESS,
    ASSIGN_USER_PERMISSIONS_FAILURE,
    REVOKE_USER_PERMISSIONS_REQUEST,
    REVOKE_USER_PERMISSIONS_SUCCESS,
    REVOKE_USER_PERMISSIONS_FAILURE,
    SYNC_USER_PERMISSIONS_REQUEST,
    SYNC_USER_PERMISSIONS_SUCCESS,
    SYNC_USER_PERMISSIONS_FAILURE,
    AVAILABLE_PERMISSIONS_REQUEST,
    AVAILABLE_PERMISSIONS_SUCCESS,
    AVAILABLE_PERMISSIONS_FAILURE,
    CLEAR_USER_PERMISSIONS_STATE
} from '../actions/types';

const initialState = {
    userPermissions: {
        user_id: null,
        role_permissions: [],
        direct_permissions: [],
        denied_permissions: [],
        all_permissions: [],
        effective_permissions: [],
        user_role: null
    },
    availablePermissions: [],
    loading: false,
    assignLoading: false,
    revokeLoading: false,
    syncLoading: false,
    availableLoading: false,
    error: null,
    success: null
};

const userPermissionsReducer = (state = initialState, action) => {
    switch (action.type) {
        case USER_PERMISSIONS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case USER_PERMISSIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                userPermissions: action.payload.data,
                error: null
            };
        case USER_PERMISSIONS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case ASSIGN_USER_PERMISSIONS_REQUEST:
            return {
                ...state,
                assignLoading: true,
                error: null,
                success: null
            };
        case ASSIGN_USER_PERMISSIONS_SUCCESS:
            return {
                ...state,
                assignLoading: false,
                success: action.payload.message,
                error: null
            };
        case ASSIGN_USER_PERMISSIONS_FAILURE:
            return {
                ...state,
                assignLoading: false,
                error: action.payload
            };

        case REVOKE_USER_PERMISSIONS_REQUEST:
            return {
                ...state,
                revokeLoading: true,
                error: null,
                success: null
            };
        case REVOKE_USER_PERMISSIONS_SUCCESS:
            return {
                ...state,
                revokeLoading: false,
                success: action.payload.message,
                error: null
            };
        case REVOKE_USER_PERMISSIONS_FAILURE:
            return {
                ...state,
                revokeLoading: false,
                error: action.payload
            };

        case SYNC_USER_PERMISSIONS_REQUEST:
            return {
                ...state,
                syncLoading: true,
                error: null,
                success: null
            };
        case SYNC_USER_PERMISSIONS_SUCCESS:
            return {
                ...state,
                syncLoading: false,
                success: action.payload.message,
                error: null
            };
        case SYNC_USER_PERMISSIONS_FAILURE:
            return {
                ...state,
                syncLoading: false,
                error: action.payload
            };

        case AVAILABLE_PERMISSIONS_REQUEST:
            return {
                ...state,
                availableLoading: true,
                error: null
            };
        case AVAILABLE_PERMISSIONS_SUCCESS:
            return {
                ...state,
                availableLoading: false,
                availablePermissions: action.payload.data,
                error: null
            };
        case AVAILABLE_PERMISSIONS_FAILURE:
            return {
                ...state,
                availableLoading: false,
                error: action.payload
            };

        case CLEAR_USER_PERMISSIONS_STATE:
            return initialState;

        default:
            return state;
    }
};

export default userPermissionsReducer; 